import { get } from "lodash";

import { useGetAnnouncementGetOneQuery } from "~/schemas/generated/graphql";

export const useAnnouncement = (id: string, skip = false) => {
  const { data, loading, refetch } = useGetAnnouncementGetOneQuery({
    variables: {
      id,
    },
    fetchPolicy: "no-cache",
    skip,
  });
  const announcement = get(data, "AnnouncementGetter.getOne", {});

  return { announcement, loading, refetch };
};
